import { render, staticRenderFns } from "./logEmail.vue?vue&type=template&id=5876a5ce&scoped=true&"
import script from "./logEmail.vue?vue&type=script&lang=js&"
export * from "./logEmail.vue?vue&type=script&lang=js&"
import style0 from "./logEmail.vue?vue&type=style&index=0&id=5876a5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876a5ce",
  null
  
)

export default component.exports